import $ from 'jquery';

"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

window.Pagination = /*#__PURE__*/function () {
    function Pagination($wrap, activeSelector) {
        var itemsPerPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 9;

        _classCallCheck(this, Pagination);

        this.paginationId = 'pagination-'+$wrap.closest('.frame').attr('id');
        this.firstTimeRender = true;
        this.firstTimePage = 1;
        this.activeSelector = activeSelector;
        this.$wrap = $wrap;
        this.itemsPerPage = itemsPerPage;
        this.pages = 0;
        this.currentPage = 1;
        this.totalCount = 0;
        this.$pageCountFilter = $wrap.find('.list-pagination__page-filter');

        var sessionPage = parseInt(sessionStorage.getItem(this.paginationId))
        if (sessionPage > 0) {
            this.firstTimePage = sessionPage;
        } else {
            this.firstTimePage = 1;
        }

        var $this = this;


        if (this.$pageCountFilter.length > 0) {
            this.itemsPerPage = parseInt(this.$pageCountFilter.val());
            this.$pageCountFilter.on('change', function () {
                $this.itemsPerPage = parseInt($this.$pageCountFilter.val());
                $this.generatePagination();
            });
        }

        $this.generatePagination();

        $wrap.on('paginationUpdate', function () {
            $this.generatePagination();
        });

        $wrap.find('.list-pagination').on("click", ".list-pagination__page", function (e) {
            e.preventDefault();
            $this.currentPage = $(this).data("page");
            $this.renderItems();
            $(window).scrollTop($wrap.find($this.activeSelector+':not(.list-pagination-item--hide)').offset().top - $('.header__bottom').height());
        });
    }

    _createClass(Pagination, [{
        key: "generatePagination",
        value: function generatePagination() {
            var $items = this.$wrap.find(this.activeSelector);
            this.totalCount = $items.length;
            this.currentPage = 1;
            this.pages = Math.ceil($items.length / this.itemsPerPage);

            if(this.pages > 0 && this.firstTimeRender === true && this.firstTimePage > 0) {
                this.firstTimeRender = false;
                this.currentPage = this.firstTimePage;
            }

            this.renderItems();
        }
    }, {
        key: "renderItems",
        value: function renderItems() {
            this.$wrap.find(this.activeSelector).addClass('list-pagination-item--hide');
            var start = this.itemsPerPage * (this.currentPage - 1);
            var end = start + this.itemsPerPage;
            this.$wrap.find(this.activeSelector).slice(start, end).removeClass('list-pagination-item--hide');
            this.renderPagination();
        }
    }, {
        key: "renderPagination",
        value: function renderPagination() {
            sessionStorage.setItem(this.paginationId, this.currentPage);

            var html = '';

            if (this.pages > 1) {
                var index = 1;
                var start = this.currentPage - 2;
                var end = this.currentPage + 2;
                html += '<a class="list-pagination__page list-pagination__page--first' + (this.currentPage != 1 ? ' list-pagination__page--disabled' : '') + '" href="#" data-page="' + (this.currentPage - 1 < 1 ? 1 : this.currentPage - 1) + '"></a>';

                if (start > 1) {
                    html += '<a class="list-pagination__page" href="#" data-page="1">...</a>';
                }

                for (var i = 0; i < this.pages; i++) {
                    index = i + 1;

                    if (index >= start && index <= end) {
                        if (index == this.currentPage) {
                            html += '<a class="list-pagination__page list-pagination__page--active" href="#" data-page="' + index + '">' + index + '</a>';
                        } else {
                            html += '<a class="list-pagination__page" href="#" data-page="' + index + '">' + index + '</a>';
                        }
                    }
                }

                if (end < this.pages) {
                    html += '<a class="list-pagination__page" href="#" data-page="' + this.pages + '">...</a>';
                }

                html += '<a class="list-pagination__page list-pagination__page--last' + (this.currentPage != this.pages ? ' list-pagination__page--disabled' : '') + '" href="#" data-page="' + (this.currentPage + 1 > this.pages ? this.pages : this.currentPage + 1) + '"></a>';
            }

            this.$wrap.find(".list-pagination").html(html);
        }
    }]);

    return Pagination;
}();
